<template>
  <div class="button b2" id="button-16">
    <input
      type="checkbox"
      class="checkbox"
      @change="changeLang"
      v-model="check"
    />
    <div class="knobs"></div>
    <div class="layer"></div>
  </div>
</template>

<script>
export default {
  name: "LanguageSwitcher",
  data() {
    return {
      check: this.$i18n.locale === "en" ? true : false,
    };
  },
  methods: {
    changeLang() {
      this.$i18n.locale = this.check === true ? "en" : "es";
    },
  },
};
</script>

<style lang="scss" scoped>
/* CSS rules are kept repetitive so that you can get CSS rules for each button easily :) */

* {
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

*:focus {
  outline: none;
}

body {
  font-family: Arial, Helvetica, sans-serif;
  margin: 0;
  background-color: #f1f9f9;
}

#app-cover {
  display: table;
  width: 600px;
  margin: 80px auto;
  counter-reset: button-counter;
}

.row {
  display: table-row;
}

.toggle-button-cover {
  display: table-cell;
  position: relative;
  width: 200px;
  height: 140px;
  box-sizing: border-box;
}

.button-cover {
  height: 100px;
  margin: 20px;
  background-color: #fff;
  box-shadow: 0 10px 20px -8px #c5d6d6;
  border-radius: 4px;
}

.button-cover:before {
  counter-increment: button-counter;
  content: counter(button-counter);
  position: absolute;
  right: 0;
  bottom: 0;
  color: #d7e3e3;
  font-size: 12px;
  line-height: 1;
  padding: 5px;
}

.button-cover,
.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.button {
  position: relative;
  top: 50%;
  width: 74px;
  height: 36px;
  margin: -20px auto 0 auto;
  overflow: hidden;
  background: transparent;
}

.button.r,
.button.r .layer {
  border-radius: 100px;
}

.button.b2 {
  border-radius: 2px;
}

.checkbox {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
  top: 0;
  left: 0;
}

.knobs {
  z-index: 2;
}

.layer {
  width: 100%;
  background-color: #fcfaeb;
  transition: 0.3s ease all;
  z-index: 1;
}
/* Button 16 */
#button-16 .knobs:before {
  content: "ES";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 20px;
  //   height: 10px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 9px 4px;
  background-color: var(--color-logo);
  border-radius: 2px;
  transition: 0.3s ease all, left 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15);
}

#button-16 .checkbox:active + .knobs:before {
  width: 46px;
}

#button-16 .checkbox:checked:active + .knobs:before {
  margin-left: -26px;
}

#button-16 .checkbox:checked + .knobs:before {
  content: "EN";
  left: 42px;
  background-color: var(--color-primary);
}

#button-16 .checkbox:checked ~ .layer {
  background-color: #ece1e1;
}
</style>
